<ion-fab vertical="top" horizontal="start" slot="fixed">
    <ion-menu-button menu="LeftMenu"></ion-menu-button>
</ion-fab>
<ion-fab vertical="top" horizontal="end" slot="fixed">
  <ion-menu-button menu="RightMenu"></ion-menu-button>
</ion-fab>
